import template from './privilege-templates-list.html';

const mapStateToThis = ({ privilegeTemplates, ui }) => {
  const { ids, entities, selectedId, isPrivilegeTemplatesListLoading } = privilegeTemplates;
  const { selectedLanguage } = ui;

  return {
    ids,
    entities,
    selectedId,
    selectedLanguage,
    isPrivilegeTemplatesListLoading,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class PrivilegeTemplatesListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class PrivilegeTemplatesListComponent {
  constructor() {
    this.template = template;
    this.controller = PrivilegeTemplatesListController;
    this.bindings = {
      selectPrivilegeTemplate: '&',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-templates-list/privilege-templates-list-component.js